import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import CustomizedButtons from "../button/button";
import CustomDatePicker from "../datePicker/datePicker";
import { Heading } from "./confirmedDialog";
import { apiBaseUrl } from "../../constant/endpoint";
import { axiosRequest } from "../../utility/axios";
import { useSelector } from "react-redux";


import { downloadExcel } from "../../helper/downloadToExcel";


// Styled components for better spacing
const ColumnDiv = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const RowDiv = styled.div`
  display: flex;
  justify-content: ${({ align }) => align || "center"};
  gap: 12px;
  margin-top: 12px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const StyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    max-width: 500px;
    max-height: 400px; /* Reducing height */
    padding: 20px;
    border-radius: 10px;
    overflow-y: auto; /* Enables scrolling if content overflows */
  }
`;


const DatepickerDialog = ({ open, handleClose, join = true, label }) => {

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [dateTime, setDateTime] = useState({ date_from: null, date_to: null });
  const [totalUser, setTotalUser] = useState("");

  const [winLossAmt, setWinLossAmt] = useState({
    win: 0,
    loss: 0,
    win_entry_fee: 0,
    loss_entry_fee: 0,
  });


  const loginSlice = useSelector((state) => state.loginSlice);
  const token = loginSlice.token;


  useEffect(() => {
    if (open) {
      setIsButtonDisabled(false);
      handleReset();
      setTotalUser("");
    }
  }, [open]);


  const handleDateChange = (name, value) => {
    setDateTime((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setIsButtonDisabled(true);
    const url = `${apiBaseUrl}/count_contest_joins?date_from=${dateTime.date_from}&date_to=${dateTime.date_to}`;
    const resContest = await axiosRequest("GET", url, token);

    if (resContest?.status === "success") {
      setTotalUser(resContest.data);
      
    }
    setIsButtonDisabled(false);
  };


 


  const handleReset = () => {
    setDateTime({ date_from: null, date_to: null });
  };

  const handleDialogClose = () => {
    handleReset();
    setTotalUser("");
    handleClose();
    setWinLossAmt({
      win: 0,
      loss: 0,
      win_entry_fee: 0,
      loss_entry_fee: 0,
    })
  };

  const handleExcelDownload = async() => {
    const winLossAmtUrl = `${apiBaseUrl}/Club_super_win_loss_excel`;
    const data = { start_date: dateTime.date_from, end_date: dateTime.date_to};
    const resWinLossAmt = await axiosRequest("POST", winLossAmtUrl, token, data);
    if (resWinLossAmt?.status === "success") {
      // console.log("resWinLossAmt?.status", resWinLossAmt?.data);
       downloadExcel(resWinLossAmt?.data, `Win_Loss_Report_${dateTime.date_from}_to_${dateTime.date_to}.xlsx`, dateTime.date_from, dateTime.date_to);
    }
    
  };
  return (

    <StyledDialog open={open} onClose={handleClose}>
      <Grid container spacing={1}>
        {/* Dialog Heading */}
        <Grid item xs={12}>
          <RowDiv align="center">
            <Heading fontSize="18px">{label}</Heading>

          </RowDiv>
        </Grid>

        {/* Date Pickers */}
        <Grid item xs={6}>
          <ColumnDiv>
            <CustomDatePicker
              label="Start Date"
              value={dateTime.date_from}
              name="date_from"
              handleOnChange={(value) => handleDateChange("date_from", value)}
            />
          </ColumnDiv>
        </Grid>

        <Grid item xs={6}>
          <ColumnDiv>
            <CustomDatePicker
              label="End Date"
              value={dateTime.date_to}
              name="date_to"
              handleOnChange={(value) => handleDateChange("date_to", value)}
            />
          </ColumnDiv>
        </Grid>


        


        {/* Displaying Total User and Win/Loss Amounts */}
        <Grid item xs={12}>
          <RowDiv>
            <Heading fontSize="14px">
              {totalUser !== "" ? `Total Users: ${totalUser}`: ''}
              {winLossAmt?.win && winLossAmt?.win_entry_fee ? (
                <div>Win: {winLossAmt?.win} (Entry: {winLossAmt?.win_entry_fee})</div>
              ): ''}
              {winLossAmt?.loss && winLossAmt?.loss_entry_fee ? (
                <div>Total Refund On Loss: {winLossAmt?.loss} (Entry: {winLossAmt?.loss_entry_fee})</div>
              ):''}
            </Heading>
          </RowDiv>
        </Grid>

        {/* Buttons */}
        <Grid item xs={12}>
        <RowDiv>
            <CustomizedButtons
              color="success"
              label="Search"
              onClick={handleSubmit}

              disabled={isButtonDisabled}

            />
            <CustomizedButtons color="primary" label="Download Excel" onClick={handleExcelDownload} />
            <CustomizedButtons color="error" label="Cancel" onClick={handleDialogClose} />
          </RowDiv>
        </Grid>
      </Grid>
    </StyledDialog>
  );
};

export default DatepickerDialog;
